export enum PerformanceTabs {
  DESCRIPTION = 'Description',
  FAQ = 'FAQ',
}
